<template>
  <fieldset id="map-bottom-point-cloud">
    <legend class="info-header font-h2">{{ iframeTitle }}</legend>
    <div class="flex-justify">
      <iframe class="cloud" :src="pointUrl"></iframe>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'MapBottomPointCloud',
  props: {
    pointUrl: {
      type: String,
      default: ''
    },
    iframeTitle: {
      type: String,
      default: '点云模型'
    }
  }
};
</script>

<style lang="scss">
#map-bottom-point-cloud {
  margin-top: 20px;
  padding: 10px 0;
  border-top: 1px solid $color-border-light;
  display: flex;
  justify-content: center;
  .cloud {
    width: 80vw;
    height: 80vh;
    border-radius: 8px;
  }
}
</style>
